import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import "./layoutStyle.css";
import Lang from "../../userPreferences/staticWords";
import $ from "jquery";
import Slider from "./slider";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearSearchKeys } from "../../API/store/actions/tasks";
import { clearCommunity, logout } from "../../API/store/actions/auth";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  currentCommunity,
  getCommunities,
  getCommunitiesWithPermssions,
} from "../../API/store/actions/community";
import ReactTooltip from "react-tooltip";
import AddMemberToCommunity from "../community/addUserToCommunity";
import ModalComponent from "./../reusableComponents/modal";
import { paths } from "../../paths/paths";
import CommunityRoles from "../community/editCommunityRoles";
import { userLang } from "../../API/store/actions/userActions";
import { setStorageValue } from "../../algorithms/storage";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import BackIcon from "../BackIcon/BackIcon";

const MainNavbar = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login.userData);
  const userToken = useSelector((state) => state.login.userToken);
  const community = useSelector((state) => state.community.communityId);
  const [openSlider, setOpenSlider] = useState(false);
  const [userCommunity, setUserCommunity] = useState(user?.community);
  const [data, setData] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [editRolesModalVisible, setEditRolesModalVisible] = useState(false);
  useEffect(() => {
    if (openSlider) {
      resolver(
        getCommunitiesWithPermssions,
        setData,
        currentPage + 1,
        2,
        userToken
      );
    }
  }, [currentPage, openSlider]);

  useEffect(() => {
    if (user?.community && !community) {
      dispatch(
        currentCommunity({
          ...user?.community,
        })
      );
    }
  }, [user?.community]);

  function toggleDropDown(e) {
    if (
      e.target.classList.contains("dropdown") ||
      e.target.classList.contains("dropbtn") ||
      e.target.classList.contains("any")
    ) {
      $("#titleArrowDropdown").hide();
      $("#titleMyDropdown").hide();
      $("#sideArrowDropdown").hide();
      $("#sideMyDropdown").hide();
      $("#arrowDropdown").toggle();
      $("#myDropdown").toggle();
      e.stopPropagation();
    }
  }

  function titleToggleDropDown(e) {
    if (
      e.target.classList.contains("titleDropdown") ||
      e.target.classList.contains("titleDropbtn") ||
      e.target.classList.contains("titleAny")
    ) {
      $("#arrowDropdown").hide();
      $("#myDropdown").hide();
      $("#sideArrowDropdown").hide();
      $("#sideMyDropdown").hide();
      $("#titleArrowDropdown").toggle();
      $("#titleMyDropdown").toggle();
      e.stopPropagation();
    }
  }

  function sideToggleDropDown(e) {
    $(".sideAny svg path").addClass("sideAny");
    if (
      e.target.classList.contains("sideDropdown") ||
      e.target.classList.contains("sideDropbtn") ||
      e.target.classList.contains("sideAny")
    ) {
      $("#arrowDropdown").hide();
      $("#myDropdown").hide();
      $("#titleArrowDropdown").hide();
      $("#titleMyDropdown").hide();
      $("#sideArrowDropdown").toggle();
      $("#sideMyDropdown").toggle();
      e.stopPropagation();
    }
  }

  // Close the dropdown if the user clicks outside of it
  $(document).on("click", function () {
    $("#arrowDropdown").hide();
    $("#myDropdown").hide();
    $("#titleArrowDropdown").hide();
    $("#titleMyDropdown").hide();
    $("#sideArrowDropdown").hide();
    $("#sideMyDropdown").hide();
    let plusElements = document.querySelectorAll(".plusIcon");
    let barsElements = document.querySelectorAll(".barsIcon");
    let TitleElements = document.querySelectorAll(".titleDropdown");
    for (
      let i = 0;
      i < plusElements.length ||
      i < barsElements?.length ||
      i < TitleElements?.length;
      i++
    ) {
      plusElements[i]?.classList?.remove("iconsBackgroundActiveClass");
      plusElements[i]?.children[0]?.classList?.remove("iconsActiveClass");
      TitleElements[i]?.classList?.remove("iconsBackgroundActiveClass");
      TitleElements[i]?.children[0]?.classList?.remove("iconsActiveClass");
      if (barsElements.length > 0) {
        barsElements[i]?.classList?.remove("iconsBackgroundActiveClass");
        barsElements[i]?.children[0]?.classList?.remove("iconsActiveClass");
      }
    }
    setOpenSlider(false);
  });

  const changeSidebarElementsActiveClass = (element) => {
    dispatch(clearSearchKeys());
    let elements = document.querySelectorAll(".iconItem");
    let accessKey = element.currentTarget.accessKey;
    let navElements = document.querySelectorAll(".itemNav");
    for (let i = 0; i < elements?.length; i++) {
      navElements[i]?.classList?.remove("iconsBackgroundActiveClass");
      navElements[i]?.children[0]?.classList?.remove("iconsActiveClass");
    }
    let sideElements = document.querySelectorAll(".item");
    for (let i = 0; i < elements?.length; i++) {
      elements[i]?.classList?.remove("activeClass");
      sideElements[i]?.classList?.remove("activeClass");
      if (accessKey == sideElements[i]?.getAttribute("accesskey")) {
        sideElements[i]?.classList?.add("activeClass");
      }
    }
    element?.currentTarget?.classList?.add("activeClass");
  };

  const changeNavElementActiveClass = (element) => {
    dispatch(clearSearchKeys());
    let elements = document.querySelectorAll(".titleDropdown");
    const targetClasses = element?.currentTarget?.classList;
    const targetChildClasses = element?.currentTarget?.children[0]?.classList;

    if (!targetChildClasses?.contains("iconsActiveClass")) {
      for (let i = 0; i < elements?.length; i++) {
        if (!targetChildClasses.contains("iconsActiveClass")) {
          elements[i]?.classList?.remove("iconsBackgroundActiveClass");
          elements[i]?.children[0]?.classList?.remove("iconsActiveClass");
        }
      }

      // if (!targetChildClasses?.contains("iconsActiveClass")) {
      //   targetChildClasses?.add("iconsActiveClass");
      //   targetClasses?.add("iconsBackgroundActiveClass");
      // }
    } else {
      targetChildClasses?.remove("iconsActiveClass");
      targetClasses?.remove("iconsBackgroundActiveClass");
    }
  };

  const changeSidebarActiveClass = (element) => {
    dispatch(clearSearchKeys());
    let elements = document.querySelectorAll(".barsIcon");
    let NavElements = document.querySelectorAll(".itemNav");

    const targetClasses = element?.currentTarget?.classList;
    const targetChildClasses = element?.currentTarget?.children[0]?.classList;

    if (!targetChildClasses?.contains("iconsActiveClass")) {
      for (let i = 0; i < elements?.length; i++) {
        if (!targetChildClasses?.contains("iconsActiveClass")) {
          elements[i]?.classList?.remove("iconsBackgroundActiveClass");
          elements[i]?.children[0]?.classList?.remove("iconsActiveClass");
        }
      }

      for (let i = 0; i < NavElements?.length; i++) {
        if (
          NavElements[i]?.children[0]?.classList?.contains("iconsActiveClass")
        ) {
          NavElements[i]?.children[0]?.classList?.remove("iconsActiveClass");
          NavElements[i]?.classList?.remove("iconsBackgroundActiveClass");
        }
      }
    } else {
      targetChildClasses?.remove("iconsActiveClass");
      targetClasses?.remove("iconsBackgroundActiveClass");
    }
  };

  const changeElementActiveClass = (element) => {
    dispatch(clearSearchKeys());
    let elements = document.querySelectorAll(".itemNav");
    document
      .getElementsByClassName("tasks")
      ?.item(0)
      ?.classList?.remove("activeClass");
    document
      .getElementsByClassName("tasks")
      ?.item(1)
      ?.classList?.remove("activeClass");
    document
      .getElementsByClassName("notificationsIndex")
      ?.item(0)
      ?.classList?.remove("activeClass");
    document
      .getElementsByClassName("notificationsIndex")
      ?.item(1)
      ?.classList?.remove("activeClass");
    // document
    //   .getElementsByClassName("project")
    //   ?.item(0)
    //   ?.classList?.remove("activeClass");
    // document
    //   .getElementsByClassName("project")
    //   ?.item(1)
    //   ?.classList?.remove("activeClass");
    // document
    //   .getElementsByClassName("discussion")
    //   ?.item(0)
    //   ?.classList?.remove("activeClass");
    // document
    //   .getElementsByClassName("discussion")
    //   ?.item(1)
    //   ?.classList?.remove("activeClass");
    document
      .getElementsByClassName("workteam")
      ?.item(0)
      ?.classList?.remove("activeClass");
    document
      .getElementsByClassName("workteam")
      ?.item(1)
      ?.classList?.remove("activeClass");
    document
      .getElementsByClassName("files")
      ?.item(0)
      ?.classList?.remove("activeClass");
    document
      .getElementsByClassName("files")
      ?.item(1)
      ?.classList?.remove("activeClass");
    // document
    //   .getElementsByClassName("infoPanel")
    //   ?.item(0)
    //   ?.classList?.remove("activeClass");
    // document
    //   .getElementsByClassName("infoPanel")
    //   ?.item(1)
    //   ?.classList?.remove("activeClass");
    const targetClasses = element?.currentTarget?.classList;
    const targetChildClasses = element?.currentTarget?.children[0]?.classList;
    if (!targetChildClasses?.contains("iconsActiveClass")) {
      for (let i = 0; i < elements?.length; i++) {
        if (!targetChildClasses?.contains("iconsActiveClass")) {
          elements[i]?.classList?.remove("iconsBackgroundActiveClass");
          elements[i]?.children[0]?.classList?.remove("iconsActiveClass");
        }
      }

      if (!targetChildClasses?.contains("iconsActiveClass")) {
        targetChildClasses?.add("iconsActiveClass");
        targetClasses?.add("iconsBackgroundActiveClass");
      } else {
        targetChildClasses?.remove("iconsActiveClass");
        targetClasses?.remove("iconsBackgroundActiveClass");
      }
    }
  };

  const removeElementActiveClass = () => {
    let elements = document.querySelectorAll(".plusIcon");
    for (let i = 0; i < elements?.length; i++) {
      elements[i]?.classList?.remove("iconsBackgroundActiveClass");
      elements[i]?.children[0]?.classList.remove("iconsActiveClass");
    }
  };

  useEffect(() => {
    if (window.location.href.includes("task")) {
      document
        .getElementsByClassName("tasks")
        ?.item(0)
        ?.classList?.add("activeClass");
      document
        .getElementsByClassName("tasks")
        ?.item(1)
        ?.classList?.add("activeClass");
    }
    // else if (
    //   window.location.href.includes("project") ||
    //   window.location.href.includes("activity")
    // ) {
    //   document
    //     .getElementsByClassName("project")
    //     ?.item(0)
    //     ?.classList?.add("activeClass");
    //   document
    //     .getElementsByClassName("project")
    //     ?.item(1)
    //     ?.classList?.add("activeClass");
    // }
    // else if (window.location.href.includes("discussion")) {
    //   document
    //     .getElementsByClassName("discussion")
    //     ?.item(0)
    //     ?.classList?.add("activeClass");
    //   document
    //     .getElementsByClassName("discussion")
    //     ?.item(1)
    //     ?.classList?.add("activeClass");
    // }
    else if (window.location.href.includes("workTeam")) {
      document
        .getElementsByClassName("workteam")
        ?.item(0)
        ?.classList?.add("activeClass");
      document
        .getElementsByClassName("workteam")
        ?.item(1)
        ?.classList?.add("activeClass");
    } else if (window.location.href.includes("notificationsIndex")) {
      document
        .getElementsByClassName("notificationsIndex")
        ?.item(0)
        ?.classList?.add("activeClass");
      document
        .getElementsByClassName("notificationsIndex")
        ?.item(1)
        ?.classList?.add("activeClass");
    } else if (window.location.href.includes("files")) {
      document
        .getElementsByClassName("files")
        ?.item(0)
        ?.classList?.add("activeClass");
      document
        .getElementsByClassName("files")
        ?.item(1)
        ?.classList?.add("activeClass");
    }
    // else if (window.location.href.includes("dashboard")) {
    //   document
    //     .getElementsByClassName("infoPanel")
    //     ?.item(0)
    //     ?.classList?.add("activeClass");
    //   document
    //     .getElementsByClassName("infoPanel")
    //     ?.item(1)
    //     ?.classList?.add("activeClass");
    // }
    else if (window.location.href.includes("adminCommunity")) {
      document
        .getElementsByClassName("adminCommunity")
        ?.item(0)
        ?.classList?.add("iconsBackgroundActiveClass");
      document
        .getElementsByClassName("adminCommunity")
        ?.item(0)
        ?.children[0]?.classList.add("iconsActiveClass");
    } else if (window.location.href.includes("admin")) {
      document
        .getElementsByClassName("admin")
        ?.item(0)
        ?.classList?.add("iconsBackgroundActiveClass");
      document
        .getElementsByClassName("admin")
        ?.item(0)
        ?.children[0]?.classList.add("iconsActiveClass");
    } else if (window.location.href.includes("lookups")) {
      document
        .getElementsByClassName("lookups")
        ?.item(0)
        ?.classList?.add("iconsBackgroundActiveClass");
      document
        .getElementsByClassName("lookups")
        ?.item(0)
        ?.children[0]?.classList.add("iconsActiveClass");
    } else if (window.location.href.includes("profile")) {
      document
        .getElementsByClassName("plusIcon")
        ?.item(0)
        ?.classList?.add("iconsBackgroundActiveClass");
      document
        .getElementsByClassName("plusIconChild")
        ?.item(0)
        ?.classList.add("iconsActiveClass");
    }
  }, []);

  const userLogged = useSelector((state) => state.login.userData);

  return (
    <>
      <ModalComponent
        hasImage={
          <img
            src={"/assets/images/Group 8275.png"}
            width={"100%"}
            height={"100%"}
          />
        }
        title={Lang.addMemberToCommunity}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        body={
          <AddMemberToCommunity
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            userToken={userToken}
          />
        }
      />

      <ModalComponent
        hasImage={
          <img
            src={"/assets/images/icons/Group 8345.png"}
            width={"100%"}
            height={"100%"}
          />
        }
        title={Lang.setRolesForCommunities}
        modalVisible={editRolesModalVisible}
        setModalVisible={setEditRolesModalVisible}
        body={
          <CommunityRoles
            modalVisible={editRolesModalVisible}
            setModalVisible={setEditRolesModalVisible}
            userToken={userToken}
          />
        }
      />
      {/* header */}
      <nav
        className="w-100 d-flex  flex-wrap-reverse m-0 header py-2 sticky-top"
        style={{
          backgroundImage: "linear-gradient(to right, #0C574C, #1A5729)",
        }}
      >
        <div className="w-100 d-flex align-items-center flex-wrap-reverse m-0 header sticky-top px-md-5 px-3">
          <div className="col-7 d-flex align-items-center justify-content-start home-link-wrapper">
            <Link
              className="home-link"
              to={"/homePage"}
              style={{
                height: 70,
                // projects version
                // background: `${"url('/assets/images/Group 8405.png') 0% 0% no-repeat padding-box"}`,
                width: 100,
                opacity: 1,
                backgroundSize: "contain",
                backgroundPosition: "center",
              }}
            ></Link>
            <Link to={"/homePage"} className="home-link-title">
              منظومة متابعة الاجراءات التنفيذية للبريكس
            </Link>
          </div>

          <div className="col-5 d-flex align-items-center justify-content-end">
            <ul className="nav stickyClass mt-lg-0 align-items-center p-0">
              {userLogged?.isAdmin ? (
                <li data-tip data-for={customStyle("li12")}>
                  <ReactTooltip
                    id={customStyle("li12")}
                    type="info"
                    effect="solid"
                    place={"bottom"}
                    backgroundColor="#12AAC4"
                    arrowColor="transparent"
                  >
                    <span>{Lang.lookups}</span>
                  </ReactTooltip>
                  {/* <Link to="/lookups">
                    <div
                      style={{
                        height: 34,
                        width: 34,
                        cursor: "pointer",
                        borderRadius: "50%",
                        filter: "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.2))",
                      }}
                      className="d-flex justify-content-center text-center align-items-center mx-2 itemNav lookups"
                      onClick={(e) => {
                        changeElementActiveClass(e);
                      }}
                    >
                      <div
                        style={{
                          width: 30,
                          height: 32,
                          background:
                            "url('/assets/images/Group 8313 (1).png') no-repeat",
                          opacity: 1,
                          backgroundSize: "contain",
                          backgroundPosition: "center",
                          filter: "brightness(0) invert(1)",
                        }}
                      ></div>
                    </div>
                  </Link> */}
                </li>
              ) : null}

              {userLogged?.isAdmin ? (
                <li data-tip data-for={customStyle("li8")}>
                  <ReactTooltip
                    id={customStyle("li8")}
                    type="info"
                    effect="solid"
                    place={"bottom"}
                    backgroundColor="rgb(12, 87, 76)"
                    arrowColor="transparent"
                  >
                    <span>{Lang.communitiesMenu}</span>
                  </ReactTooltip>
                  <Link to="/adminCommunity">
                    <div
                      style={{
                        height: 34,
                        width: 34,
                        cursor: "pointer",
                        borderRadius: "50%",
                        filter: "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.2))",
                      }}
                      className="d-flex justify-content-center text-center align-items-center mx-2 itemNav adminCommunity"
                      onClick={(e) => {
                        changeElementActiveClass(e);
                      }}
                    >
                      <div
                        style={{
                          width: 30,
                          height: 28,
                          background:
                            "url('/assets/images/sync.png') no-repeat",
                          opacity: 1,
                          backgroundSize: "contain",
                          backgroundPosition: "center",
                          filter: "brightness(0) invert(1)",
                        }}
                      ></div>
                    </div>
                  </Link>
                </li>
              ) : null}

              {userLogged?.isAdmin ? (
                <li data-tip data-for={customStyle("li9")}>
                  <ReactTooltip
                    id={customStyle("li9")}
                    type="info"
                    effect="solid"
                    place={"bottom"}
                    backgroundColor="rgb(12, 87, 76)"
                    arrowColor="transparent"
                  >
                    <span>{Lang.workTeam}</span>
                  </ReactTooltip>
                  <Link to="/admin">
                    <div
                      style={{
                        height: 33,
                        width: 33,
                        cursor: "pointer",
                        borderRadius: "50%",
                        filter: "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.2))",
                      }}
                      className="d-flex justify-content-center text-center align-items-center mx-2 itemNav admin"
                      onClick={(e) => {
                        changeElementActiveClass(e);
                        removeElementActiveClass();
                      }}
                    >
                      <div
                        style={{
                          width: 25,
                          height: 26,
                          background: "url('/assets/images/customer (1).png')",
                          opacity: 1,
                          backgroundSize: "contain",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          filter: "brightness(0) invert(1)",
                        }}
                      ></div>
                    </div>
                  </Link>
                </li>
              ) : null}

              <li>
                <div
                  style={{
                    height: 34,
                    width: 34,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className={`d-flex justify-content-center text-center align-items-center dropdown dropbtn itemNav ${
                    getDir(getCurrentLangFromRedux()) == "rtl" ? "me-2" : "mx-2"
                  } plusIcon`}
                  onClick={(e) => {
                    changeElementActiveClass(e);
                    toggleDropDown(e);
                  }}
                >
                  <div
                    style={{
                      width: 28,
                      height: 28,
                      background: "url('/assets/images/icons/Group 8329.png')",
                      opacity: 1,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      filter: "brightness(0) invert(1)",
                    }}
                    className="any plusIconChild"
                  ></div>
                  <div
                    id="arrowDropdown"
                    className={`${customStyle("arrow-up")}`}
                  ></div>
                  <div
                    id="myDropdown"
                    className={`${customStyle("dropdown-content")}`}
                  >
                    {/* <Link
                      className={`d-flex ${
                        window.location.href.includes("profile")
                          ? "activeClass"
                          : ""
                      }`}
                      to={"/profile"}
                    >
                      <div
                        style={{
                          height: 25,
                          width: 25,
                          cursor: "pointer",
                          background: "url('/assets/images/icons/user.png')",
                          backgroundPosition: "center",
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          filter:
                            "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.2))",
                        }}
                        className={`d-flex justify-content-center text-center align-items-center itemNav ${styleEnd(
                          "m",
                          2
                        )}`}
                      ></div>
                      <div className="d-flex align-items-center">
                        <p className="mb-0">{Lang.profile}</p>
                      </div>
                    </Link> */}
                    {/* <a
                      className="d-flex"
                      onClick={(e) => {
                        setStorageValue(
                          "language",
                          Lang.getLanguage() == "ar" ? "en" : "ar"
                        );
                        // dispatch(
                        //   userLang(Lang.getLanguage() == "ar" ? "en" : "ar")
                        // );
                        Lang.setLanguage(
                          Lang.getLanguage() == "ar" ? "en" : "ar"
                        );
                        window.location.reload();

                        // Lang.setLanguage("ar");
                        // e.preventDefault();
                      }}
                    >
                      <div
                        style={{
                          height: 24,
                          width: 24,
                          cursor: "pointer",

                          filter:
                            "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.2))",
                        }}
                        className={`d-flex justify-content-center text-center align-items-center itemNav ${styleEnd(
                          "m",
                          2
                        )}`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                        >
                          <path
                            id="web"
                            d="M16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Zm8.941,10H20.97a18.5,18.5,0,0,0-1.657-7.36A9.014,9.014,0,0,1,24.941,15ZM16,25c-1.148,0-2.781-3.084-2.98-8h5.96C18.781,21.916,17.148,25,16,25ZM13.02,15c.2-4.916,1.832-8,2.98-8s2.781,3.084,2.98,8Zm-.333-7.36A18.5,18.5,0,0,0,11.03,15H7.059a9.014,9.014,0,0,1,5.628-7.36ZM7.059,17H11.03a18.5,18.5,0,0,0,1.657,7.36A9.014,9.014,0,0,1,7.059,17Zm12.254,7.36A18.5,18.5,0,0,0,20.97,17h3.971A9.014,9.014,0,0,1,19.313,24.36Z"
                            transform="translate(-5 -5)"
                            fill="#444"
                          />
                        </svg>
                      </div>
                      <div className="d-flex align-items-center">
                        <p className="mb-0">{Lang.language}</p>
                      </div>
                    </a> */}

                    <a
                      className="d-flex"
                      onClick={(e) => {
                        dispatch(logout());
                        dispatch(clearCommunity());
                      }}
                    >
                      <div
                        style={{
                          height: 24,
                          width: 24,
                          cursor: "pointer",
                          background: "url('/assets/images/icons/signout.png')",
                          backgroundPosition: "center",
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          filter:
                            "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.2))",
                        }}
                        className={`d-flex justify-content-center text-center align-items-center itemNav ${styleEnd(
                          "m",
                          2
                        )}`}
                      ></div>
                      <div className="d-flex align-items-center">
                        <p className="mb-0">{Lang.logout}</p>
                      </div>
                    </a>
                  </div>
                </div>
              </li>

              {/* <li>
                <a
                  href="https://idsc.gov.eg/"
                  target={"_blank"}
                  className="d-flex justify-content-center text-center align-items-center"
                  rel="noreferrer"
                >
                  <div
                    style={{
                      width: 300,
                      height: 55,
                      background: `${
                        getDir(getCurrentLangFromRedux()) == "rtl"
                          ? "url('/assets/images/Group 8293.png') 0% 0% no-repeat padding-box"
                          : "url('/assets/images/Group 8340.png') 0% 0% no-repeat padding-box"
                      }`,

                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      opacity: 1,
                    }}
                  ></div>
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>

      {/* Main Nav */}
      <nav className="w-100 row m-0 mainNav py-2 d-none ">
        {/* title section */}
        <div className="col-md-6 col-12 d-flex align-items-center justify-content-lg-start justify-content-center py-2 px-0">
          <div
            style={{
              backgroundColor: "white",
              height: 32,
              width: 32,
              cursor: "pointer",
              borderRadius: "4px",
            }}
            className={`d-flex justify-content-center text-center align-items-center titleDropdown titleDropbtn ${styleStart(
              "m",
              5
            )}  ${styleEnd("m", 2)}`}
            onClick={(e) => {
              changeNavElementActiveClass(e);
              titleToggleDropDown(e);
              removeElementActiveClass();
              setOpenSlider(!openSlider);
            }}
          >
            <div
              style={{
                width: 24,
                height: 26,
                background: community?.logo
                  ? // ? `url('${paths.CommunityLogo}${userCommunity?.communityId}/${userCommunity?.logo}') center center / contain no-repeat`
                    // : community?.logo
                    `url('${paths.CommunityLogo}${community?.id}/${community?.logo}') center center / contain no-repeat`
                  : "url('/assets/images/sync-1.png') center center / contain no-repeat",
                opacity: 1,
              }}
              className="titleAny"
            ></div>
          </div>
          <div
            className="col titleAny text-white fw-bold"
            style={{ fontSize: 16 }}
          >
            {community?.name}
          </div>
          <div
            id="titleArrowDropdown"
            className={`${customStyle("title-arrow-up")}`}
          ></div>
          <div
            id="titleMyDropdown"
            className={`${customStyle("title-dropdown-content")}`}
            style={{ width: "70%" }}
          >
            <Slider
              openSlider={openSlider}
              setOpenSlider={setOpenSlider}
              setCurrentPage={setCurrentPage}
              data={data}
              currentPage={currentPage}
            />
          </div>
        </div>

        {/* Icons section */}
        {/* add sidebar menu in small screens*/}
        <div
          className={`col-md-6 col-12 d-flex align-items-center py-2 px-0 justify-content-end`}
        >
          {props.haveSidebar === true ? (
            <div
              style={{
                backgroundColor: "white",
                height: 32,
                width: 32,
                cursor: "pointer",
                borderRadius: "50%",
                position: "absolute",
              }}
              className={`justify-content-center text-center align-items-center sideDropdown sideDropbtn itemNav barsIcon sidebarIcon ${customStyle(
                "menuIcon"
              )}`}
              onClick={(e) => {
                // changeSidebarActiveClass(e);
                sideToggleDropDown(e);
              }}
            >
              <Icon
                size={16}
                color="#1a73e8"
                name="bars"
                className="sideAny"
                style={{ display: "block" }}
              />

              <div
                id="sideArrowDropdown"
                className={`${customStyle("side-arrow-up")}`}
              ></div>
              <div
                id="sideMyDropdown"
                className={`${customStyle("side-dropdown-content")}`}
                style={{ width: 210 }}
              >
                <ul style={{ overflowY: "auto" }} className="nav p-0">
                  <li
                    className="iconItem w-100 homePage"
                    onClick={(e) => {
                      changeSidebarElementsActiveClass(e);
                      changeSidebarActiveClass(e);
                    }}
                    accessKey="50"
                  >
                    <Link
                      to="/homePage"
                      className="d-flex align-items-center text-decoration-none px-3"
                    >
                      <div
                        style={{
                          height: 32,
                          width: 32,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center m-1"
                      >
                        <div
                          style={{
                            width: 24,
                            height: 24,
                            background:
                              "url('/assets/images/icons/projection-screen.png') 0% 0% no-repeat padding-box",
                            opacity: 1,
                          }}
                        ></div>
                      </div>
                      <div className="text-center">{"الرئيسية"}</div>
                    </Link>
                  </li>

                  <li
                    className="iconItem w-100 tasks"
                    onClick={(e) => {
                      changeSidebarActiveClass(e);
                      changeSidebarElementsActiveClass(e);
                    }}
                    accessKey="2"
                  >
                    <Link
                      to="/tasks/index"
                      className="d-flex align-items-center text-decoration-none px-3"
                    >
                      <div
                        style={{
                          height: 32,
                          width: 32,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center m-1"
                      >
                        <div
                          // className="icon1"
                          style={{
                            width: 24,
                            height: 24,
                            // background:
                            //   "url('/assets/images/icon1.svg') 0% 0% no-repeat padding-box",
                            opacity: 1,
                          }}
                        ></div>
                      </div>

                      <div className="text-center">{Lang.tasksNavTab}</div>
                    </Link>
                  </li>

                  {/* <li
                    className="iconItem w-100"
                    onClick={(e) => {
                      changeSidebarElementsActiveClass(e);
                    }}
                    accessKey="3"
                  >
                    <a
                      href="#"
                      className="d-flex align-items-center text-decoration-none px-3"
                    >
                      <div
                        style={{
                          height: 32,
                          width: 32,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center m-1"
                      >
                        <div
                          style={{
                            width: 24,
                            height: 24,
                            background:
                              "url('/assets/images/icons/fi-br-calendar.png') 0% 0% no-repeat padding-box",
                            opacity: 1,
                          }}
                        ></div>
                      </div>
                      <div className="text-center">{Lang.calenderNavTab}</div>
                    </a>
                  </li>*/}

                  {/* <li
                    className="iconItem w-100 discussion"
                    onClick={(e) => {
                      changeSidebarActiveClass(e);
                      changeSidebarElementsActiveClass(e);
                    }}
                    accessKey="4"
                  >
                    <Link
                      to="/discussion"
                      className="d-flex align-items-center text-decoration-none px-3"
                    >
                      <div
                        style={{
                          height: 32,
                          width: 32,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center m-1"
                      >
                        <div
                          style={{
                            width: 24,
                            height: 24,
                            background:
                              "url('/assets/images/icons/fi-br-comments.png') 0% 0% no-repeat padding-box",
                            opacity: 1,
                          }}
                        ></div>
                      </div>
                      <div className="text-center">
                        {Lang.discussionCirclesNavTab}
                      </div>
                    </Link>
                  </li> */}

                  <li
                    className="iconItem w-100 files"
                    onClick={(e) => {
                      changeSidebarActiveClass(e);
                      changeSidebarElementsActiveClass(e);
                    }}
                    accessKey="5"
                  >
                    <Link
                      to="/files"
                      className="d-flex align-items-center text-decoration-none px-3"
                    >
                      <div
                        style={{
                          height: 32,
                          width: 32,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center m-1"
                      >
                        <div
                          style={{
                            width: 22,
                            height: 22,
                            background:
                              "url('/assets/images/icons/fi-br-folder.png') 0% 0% no-repeat padding-box",
                            opacity: 1,
                          }}
                        ></div>
                      </div>
                      <div className="text-center">{Lang.filesNavTab}</div>
                    </Link>
                  </li>

                  {/* <li
                    className="iconItem w-100 infoPanel"
                    onClick={(e) => {
                      changeSidebarActiveClass(e);
                      changeSidebarElementsActiveClass(e);
                    }}
                    accessKey="6"
                  >
                    <Link
                      to="/dashboard"
                      className="d-flex align-items-center text-decoration-none px-3"
                    >
                      <div
                        style={{
                          height: 32,
                          width: 32,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center m-1"
                      >
                        <div
                          style={{
                            width: 24,
                            height: 24,
                            background:
                              "url('/assets/images/icons/fi-br-signal-alt-1.png') 0% 0% no-repeat padding-box",
                            opacity: 1,
                          }}
                        ></div>
                      </div>
                      <div className="text-center">{Lang.infoPanelNavTab}</div>
                    </Link>
                  </li> */}

                  <li
                    className="iconItem w-100 workteam"
                    onClick={(e) => {
                      changeSidebarActiveClass(e);
                      changeSidebarElementsActiveClass(e);
                    }}
                    accessKey="1"
                  >
                    <Link
                      to="/workTeam"
                      className="d-flex align-items-center text-decoration-none px-3"
                    >
                      <div
                        style={{
                          height: 32,
                          width: 32,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center m-1"
                      >
                        <div
                          style={{
                            width: 24,
                            height: 24,
                            background:
                              "url('/assets/images/icons/group (3).png') 0% 0% no-repeat padding-box",
                            opacity: 1,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                          }}
                        ></div>
                      </div>
                      <div className="text-center">{Lang.workTeam}</div>
                    </Link>
                  </li>

                  <li
                    className="iconItem w-100 notificationsIndex"
                    onClick={(e) => {
                      changeSidebarActiveClass(e);
                      changeSidebarElementsActiveClass(e);
                    }}
                    accessKey="5"
                  >
                    <Link
                      to="/notificationsIndex"
                      className="d-flex align-items-center text-decoration-none px-3"
                    >
                      <div
                        style={{
                          height: 32,
                          width: 32,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center m-1"
                      >
                        <div
                          style={{
                            width: 24,
                            height: 24,
                            background:
                              "url('/assets/images/icons/bell (1).png') 0% 0% no-repeat padding-box",
                            opacity: 1,
                          }}
                        ></div>
                      </div>
                      <div className="text-center">الإشعارات</div>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          ) : null}

          {/* Icons */}
          {/* <div
            className={`search-box mx-2 ${styleStart("m", 3)}`}
            style={{
              filter: "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.5))",
            }}
          >
            <button className={`btn-search ${customStyle("icon-dir")}`}>
              <Icon size={16} color="#1a73e8" name="search" />
            </button>
            <input
              type="text"
              className="input-search"
              placeholder={Lang.searchInput}
              // onChange={(e) => {
              //   setTextSearch(e.target.value);
              //   dispatch(searchKey(e.target.value));
              // }}
            />
          </div> */}

          {/* <div
            style={{
              backgroundColor: "white",
              height: 32,
              width: 32,
              cursor: "pointer",
              borderRadius: "50%",
              filter: "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.5))",
            }}
            className="d-flex justify-content-center text-center align-items-center itemNav"
            onClick={(e) => {
              changeElementActiveClass(e);
            }}
          >
            <div
              style={{
                width: 16,
                height: 24,
                background:
                  "url('/assets/images/icons/Group 252.png') 0% 0% no-repeat padding-box",
                opacity: 1,
              }}
            ></div>
          </div> */}
          {/* 
          <div
            style={{
              backgroundColor: "white",
              height: 32,
              width: 32,
              cursor: "pointer",
              borderRadius: "50%",
              filter: "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.5))",
            }}
            className="d-flex justify-content-center text-center align-items-center mx-2 itemNav"
            onClick={(e) => {
              changeElementActiveClass(e);
            }}
          >
            <div
              style={{
                width: 20,
                height: 20,
                background:
                  "url('/assets/images/icons/Group 96.png') 0% 0% no-repeat padding-box",
                opacity: 1,
              }}
            ></div>
          </div> */}

          {/* <div
            style={{
              backgroundColor: "white",
              height: 32,
              width: 32,
              cursor: "pointer",
              borderRadius: "50%",
            }}
            className="d-flex justify-content-center text-center align-items-center dropdown dropbtn itemNav plusIcon"
            onClick={(e) => {
              changeElementActiveClass(e);
              toggleDropDown(e);
            }}
          >
            <div
              style={{
                width: 16,
                height: 16,
                background:
                  "url('/assets/images/icons/Path 184.png') 0% 0% no-repeat padding-box",
                opacity: 1,
              }}
              className="any"
            ></div>
            <div
              id="arrowDropdown"
              className={`${customStyle("arrow-up")}`}
            ></div>
            <div
              id="myDropdown"
              className={`${customStyle("dropdown-content")}`}
            >
              <a href="#home" className="px-4 py-2">
                {Lang.addCommunity}
              </a>
              <a href="#about" className="px-4 py-2">
                {Lang.addProject}
              </a>
              <a href="#contact" className="px-4 py-2">
                {Lang.addTask}
              </a>
              <a href="#contact" className="px-4 py-2">
                {Lang["addQuestion/Discuss"]}
              </a>
            </div>
          </div> */}

          <ul className="nav stickyClass mt-lg-0 mx-5">
            {community?.adminCommunity && (
              <>
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                    filter: "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.5))",
                  }}
                  className="d-flex justify-content-center text-center align-items-center mx-2 itemNav"
                  onClick={(e) => {
                    // changeElementActiveClass(e);
                    setModalVisible(!modalVisible);
                  }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      background:
                        "url('/assets/images/icons/Group 8279.png') no-repeat",
                      opacity: 1,
                      backgroundPosition: "center",
                      backgroundSize: "contain",
                    }}
                    data-tip
                    data-for={customStyle("li11")}
                  >
                    <ReactTooltip
                      id={customStyle("li11")}
                      type="info"
                      effect="solid"
                      place={
                        getDir(getCurrentLangFromRedux()) == "rtl"
                          ? "right"
                          : "left"
                      }
                      backgroundColor="#12AAC4"
                      arrowColor="#12AAC4"
                    >
                      <span>{Lang.addMemberToCommunity}</span>
                    </ReactTooltip>
                  </div>
                </div>
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                    filter: "drop-shadow(0px 0px 3px rgba(50, 50, 0, 0.5))",
                  }}
                  className="d-flex justify-content-center text-center align-items-center mx-2 itemNav"
                  onClick={(e) => {
                    // changeElementActiveClass(e);
                    setEditRolesModalVisible(!editRolesModalVisible);
                  }}
                >
                  <div
                    style={{
                      width: 25,
                      height: 25,
                      background:
                        "url('/assets/images/icons/Group 8344.png') no-repeat",
                      opacity: 1,
                      backgroundPosition: "center",
                      backgroundSize: "contain",
                    }}
                    data-tip
                    data-for={customStyle("li13")}
                  >
                    <ReactTooltip
                      id={customStyle("li13")}
                      type="info"
                      effect="solid"
                      place={
                        getDir(getCurrentLangFromRedux()) == "rtl"
                          ? "right"
                          : "left"
                      }
                      backgroundColor="#12AAC4"
                      arrowColor="#12AAC4"
                    >
                      <span>{Lang.setRolesForCommunities}</span>
                    </ReactTooltip>
                  </div>
                </div>
              </>
            )}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default MainNavbar;
